import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Confirmation")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("confirm (un)follow?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "cup_23" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    confirm: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "flex-1 btn primary",
        progress: _ctx.progress,
        onClick: _ctx.toggle
      }, {
        default: _withCtx(() => [
          _createVNode(_component_t, {
            path: "withdrawal_31",
            custom: ""
          }, {
            default: _withCtx(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Confirm'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["progress", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_t, {
        class: "t-center",
        path: _ctx.isFollow?'cup_26':'cup_24',
        args: {trader: _ctx.masterName}
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["path", "args"])
    ]),
    _: 1
  }))
}